import React from 'react'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useSelector } from 'react-redux'
import AltaHorasExtras1 from './Incidencias/AltaHorasExtras1';
import AltaPermisoConG from './Incidencias/AltaPermisoConG';
import AltaPermisoConSinG from './Incidencias/AltaPermisoConSinG';
import AltaFaltasInjustificadas from './Incidencias/AltaFaltasInjustificadas';
import AltaRetardos from './Incidencias/AltaRetardos';
import AltaAccidenteTrabajo from './Incidencias/AltaAccidenteTrabajo';
import AltaEnfermedadGyLicencia140 from './Incidencias/AltaEnfermedadGyLicencia140';

const AltaIncidencias = (props) => {
  const { lote } = props
  const { periodo } = props
  const { idempleado } = props
  const { notificacion } = props
  const { obtenerdatolote } = props
  const { datotodoempleado } = props

  const [tipo, setTipo] = React.useState('');

  const incidenciasmenu = useSelector(store => store.menus.incidencias)


  const handleChange = (event) => {
    setTipo(event.target.value);
  };
  return (
    <div>
      <FormControl fullWidth size="small">
        <InputLabel id="demo-simple-select-label">Tipo</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={tipo}
          label="Tipo"
          onChange={handleChange}
        >
          {
            incidenciasmenu.map((row, Index) =>
              <MenuItem key={Index} value={row.idtipoincidencia}>{row.descripcion}</MenuItem>
            )
          }

        </Select>
      </FormControl>
      {
        tipo === 1 ? (
          <>
            <AltaHorasExtras1
              idempleado={idempleado}
              lote={lote}
              periodo={periodo}
              notificacion={notificacion}
              idconcepto={tipo}
              obtenerdatolote={obtenerdatolote}
              datotodoempleado={datotodoempleado}


            />
          </>
        ) : null
      }
      {
        tipo === 2 ? (
          <>
            <AltaHorasExtras1
              idempleado={idempleado}
              lote={lote}
              periodo={periodo}
              notificacion={notificacion}
              idconcepto={tipo}
              obtenerdatolote={obtenerdatolote}
              datotodoempleado={datotodoempleado}


            />
          </>
        ) : null
      }
      {
        tipo === 3 ? (
          <>
            <AltaHorasExtras1
              idempleado={idempleado}
              lote={lote}
              periodo={periodo}
              notificacion={notificacion}
              idconcepto={tipo}
              obtenerdatolote={obtenerdatolote}
              datotodoempleado={datotodoempleado}


            />
          </>
        ) : null
      }

      {
        tipo === 4 ? (
          <>
            <AltaHorasExtras1
              idempleado={idempleado}
              lote={lote}
              periodo={periodo}
              notificacion={notificacion}
              idconcepto={tipo}
              obtenerdatolote={obtenerdatolote}
              datotodoempleado={datotodoempleado}


            />
          </>
        ) : null
      }

      {
        tipo === 5 ? (
          <>
            <AltaHorasExtras1
              idempleado={idempleado}
              lote={lote}
              periodo={periodo}
              notificacion={notificacion}
              idconcepto={tipo}
              obtenerdatolote={obtenerdatolote}
              datotodoempleado={datotodoempleado}


            />
          </>
        ) : null
      }

      {
        tipo === 7 ? (
          <>
            <AltaPermisoConG
              idempleado={idempleado}
              lote={lote}
              periodo={periodo}
              notificacion={notificacion}
              idconcepto={tipo}
              obtenerdatolote={obtenerdatolote}
              datotodoempleado={datotodoempleado}


            />
          </>
        ) : null
      }

      {
        tipo === 8 ? (
          <>
            <AltaPermisoConSinG
              idempleado={idempleado}
              lote={lote}
              periodo={periodo}
              notificacion={notificacion}
              idconcepto={tipo}
              obtenerdatolote={obtenerdatolote}
              datotodoempleado={datotodoempleado}


            />
          </>
        ) : null
      }

      {
        tipo === 9 ? (
          <>
            <AltaAccidenteTrabajo
              idempleado={idempleado}
              lote={lote}
              periodo={periodo}
              notificacion={notificacion}
              idconcepto={tipo}
              obtenerdatolote={obtenerdatolote}
              datotodoempleado={datotodoempleado}


            />
          </>
        ) : null
      }

      {
        tipo === 11 ? (
          <>
            <AltaEnfermedadGyLicencia140
              idempleado={idempleado}
              lote={lote}
              periodo={periodo}
              notificacion={notificacion}
              idconcepto={tipo}
              obtenerdatolote={obtenerdatolote}
              datotodoempleado={datotodoempleado}
            />
          </>
        ) : null
      }

      {
        tipo === 15 ? (
          <>
            <AltaFaltasInjustificadas
              idempleado={idempleado}
              lote={lote}
              periodo={periodo}
              notificacion={notificacion}
              idconcepto={tipo}
              obtenerdatolote={obtenerdatolote}
              datotodoempleado={datotodoempleado}


            />
          </>
        ) : null
      }

      {
        tipo === 17 ? (
          <>
            <AltaRetardos
              idempleado={idempleado}
              lote={lote}
              periodo={periodo}
              notificacion={notificacion}
              idconcepto={tipo}
              obtenerdatolote={obtenerdatolote}
              datotodoempleado={datotodoempleado}
            />
          </>
        ) : null
      }
  {
        tipo === 18 ? (
          <>
            <AltaEnfermedadGyLicencia140
              idempleado={idempleado}
              lote={lote}
              periodo={periodo}
              notificacion={notificacion}
              idconcepto={tipo}
              obtenerdatolote={obtenerdatolote}
              datotodoempleado={datotodoempleado}
            />
          </>
        ) : null
      }
{
        tipo === 13 ? (
          <>
            <AltaEnfermedadGyLicencia140
              idempleado={idempleado}
              lote={lote}
              periodo={periodo}
              notificacion={notificacion}
              idconcepto={tipo}
              obtenerdatolote={obtenerdatolote}
              datotodoempleado={datotodoempleado}
            />
          </>
        ) : null
      }

    </div>


  )
}

export default AltaIncidencias